import React, { createContext, useContext, useCallback, useEffect, useRef, useState } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { actions } from '../features/work-report-slice';
import { queryPlanDueOrder } from '../features/work-report-thunk';

import { OrderMonthView } from './order-month-view';

export function MonthViewPage(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(queryPlanDueOrder())
    .then(result => {
      // console.info(result);
    });
  }, [dispatch]);

  const handleOpen = useCallback(
    (value) => {
      history.push(`/work-order/${value._id}`);
      // window.open(`/work-order/${value._id}`);
    },
    [history],
  );

  return (
    <React.Fragment>
      <h2 className='text-center'>ปฏิทินกำหนดส่งงาน</h2>
      <OrderMonthView onOpen={handleOpen} />
    </React.Fragment>
  )
}